<template>
  <i :class="['b-icon', name, size, color]" v-bind="$attrs"></i>
</template>

<script>
export default {
  name: 'AppIcon',
  status: 'prototype',
  release: '1.0.0',
  props: {
    name: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => {
        return value.match(/(xs|sm|md|lg|xl)/)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";

$icomoon-font-family: "bicons" !default;
$icomoon-font-path: "../../assets/fonts/" !default;
$icon-emoji-angry: "\e92f";
$icon-emoji-mad: "\e930";
$icon-emoji-poker: "\e931";
$icon-emoji-smile: "\e932";
$icon-emoji-smiley: "\e933";
$icon-columns: "\e903";
$icon-rows: "\e923";
$icon-columns-alt: "\e927";
$icon-atm: "\e928";
$icon-calendar: "\e929";
$icon-email: "\e92a";
$icon-link: "\e92b";
$icon-sms: "\e92c";
$icon-sms-alt: "\e92d";
$icon-widget: "\e92e";
$icon-plus: "\e90a";
$icon-bell: "\e91e";
$icon-magnifier: "\e91f";
$icon-timer: "\e920";
$icon-messages-alt: "\e921";
$icon-answers: "\e924";
$icon-fullscreen: "\e925";
$icon-download: "\e926";
$icon-edit: "\e90d";
$icon-duplicate: "\e90f";
$icon-chart-line: "\e911";
$icon-trash-alt: "\e912";
$icon-star: "\e918";
$icon-messages: "\e900";
$icon-refresh: "\e901";
$icon-close-path1: "\e902";
$icon-close-path2: "\e903";
$icon-grid: "\e904";
$icon-arrow-down-alt: "\e905";
$icon-arrow-up-alt: "\e91a";
$icon-copy: "\e906";
$icon-copy-alt: "\e907";
$icon-trash: "\e908";
$icon-dashboard: "\e909";
$icon-cut: "\e90b";
$icon-star-alt: "\e90c";
$icon-number: "\e90e";
$icon-button: "\e910";
$icon-emoji: "\e913";
$icon-arrow-down: "\e914";
$icon-arrow-up: "\e915";
$icon-gear: "\e916";
$icon-radio-fill: "\e917";
$icon-radio: "\e91c";
$icon-checkbox-fill: "\e919";
$icon-alphabet: "\e91b";
$icon-align: "\e91d";
$icon-circle-fill-path1: "\e922";
$icon-circle-fill-path2: "\e923";

@font-face {
  font-family: '#{$icomoon-font-family}';
  src:  url('#{$icomoon-font-path}/#{$icomoon-font-family}.eot?2lhkzm');
  src:  url('#{$icomoon-font-path}/#{$icomoon-font-family}.eot?2lhkzm#iefix') format('embedded-opentype'),
    url('#{$icomoon-font-path}/#{$icomoon-font-family}.ttf?2lhkzm') format('truetype'),
    url('#{$icomoon-font-path}/#{$icomoon-font-family}.woff?2lhkzm') format('woff'),
    url('#{$icomoon-font-path}/#{$icomoon-font-family}.svg?2lhkzm##{$icomoon-font-family}') format('svg');
  font-weight: normal;
  font-style: normal;
}

.b-icon {
  font-family: '#{$icomoon-font-family}' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 2px;
  color: $color-rich-black;

  .path1 {
    color: $color-rich-black;
  }

  &.xs {
    font-size: 18px;
  }
  &.sm {
    font-size: 25px;
  }
  &.md {
    font-size: 35px;
  }
  &.lg {
    font-size: 45px;
  }
  &.xl {
    font-size: 55px;
  }
  &.xxl {
    font-size: 65px;
  }

  &:before {
    color: inherit;
  }

  &.purple-lighter {
    color: $color-purple-lighter;
  }
  &.purple-light {
    color: $color-purple-light;
  }
  &.purple {
    color: $color-purple;
  }
  &.purple-dark {
    color: $color-purple-dark;
  }
  &.purple-darker {
    color: $color-purple-darker;
  }
  &.gray-light {
    color: $color-gray-light;
  }
  &.gray {
    color: $color-gray;
  }
  &.gray-dark {
    color: $color-gray-dark;
  }
  &.yellow-lighter {
    color: $color-yellow-lighter;
  }
  &.yellow-light {
    color: $color-yellow-light;
  }
  &.yellow {
    color: $color-yellow;
  }
  &.green {
    color: $color-green;
  }
  &.pink-lighter {
    color: $color-pink-lighter;
  }
  &.pink-light {
    color: $color-pink-light;
  }
  &.pink {
    color: $color-pink;
  }
  &.white {
    color: $color-white;
  }
  &.rich-black {
    color: $color-rich-black;
  }
  &.emoji-angry {
    &:before {
      content: $icon-emoji-angry;
    }
  }
  &.emoji-mad {
    &:before {
      content: $icon-emoji-mad;
    }
  }
  &.emoji-poker {
    &:before {
      content: $icon-emoji-poker;
    }
  }
  &.emoji-smile {
    &:before {
      content: $icon-emoji-smile;
    }
  }
  &.emoji-smiley {
    &:before {
      content: $icon-emoji-smiley;
    }
  }
  &.columns {
    &:before {
      content: $icon-columns;
    }
  }
  &.rows {
    &:before {
      content: $icon-rows;
    }
  }
  &.columns-alt {
    &:before {
      content: $icon-columns-alt;
    }
  }
  &.atm {
    &:before {
      content: $icon-atm;
    }
  }
  &.calendar {
    &:before {
      content: $icon-calendar;
    }
  }
  &.email {
    &:before {
      content: $icon-email;
    }
  }
  &.link {
    &:before {
      content: $icon-link;
    }
  }
  &.sms {
    &:before {
      content: $icon-sms;
    }
  }
  &.sms-alt {
    &:before {
      content: $icon-sms-alt;
    }
  }
  &.widget {
    &:before {
      content: $icon-widget;
    }
  }
  &.plus {
    &:before {
      content: $icon-plus;
    }
  }
  &.bell {
    &:before {
      content: $icon-bell;
    }
  }
  &.magnifier {
    &:before {
      content: $icon-magnifier;
    }
  }
  &.timer {
    &:before {
      content: $icon-timer;
    }
  }
  &.messages-alt {
    &:before {
      content: $icon-messages-alt;
    }
  }
  &.answers {
    &:before {
      content: $icon-answers;
    }
  }
  &.fullscreen {
    &:before {
      content: $icon-fullscreen;
    }
  }
  &.download {
    &:before {
      content: $icon-download;
    }
  }
  &.edit {
    &:before {
      content: $icon-edit;
    }
  }
  &.duplicate {
    &:before {
      content: $icon-duplicate;
    }
  }
  &.chart-line {
    &:before {
      content: $icon-chart-line;
    }
  }
  &.trash-alt {
    &:before {
      content: $icon-trash-alt;
    }
  }
  &.star {
    &:before {
      content: $icon-star;
    }
  }
  &.messages {
    &:before {
      content: $icon-messages;
    }
  }
  &.refresh {
    &:before {
      content: $icon-refresh;
    }
  }
  &.close {
    &:before {
      content: $icon-close-path1;
    }
  }
  &.grid {
    &:before {
      content: $icon-grid;
    }
  }
  &.arrow-down-alt {
    &:before {
      content: $icon-arrow-down-alt;
    }
  }
  &.arrow-up-alt {
    &:before {
      content: $icon-arrow-up-alt;
    }
  }
  &.copy {
    &:before {
      content: $icon-copy;
    }
  }
  &.copy-alt {
    &:before {
      content: $icon-copy-alt;
    }
  }
  &.trash {
    &:before {
      content: $icon-trash;
    }
  }
  &.dashboard {
    &:before {
      content: $icon-dashboard;
    }
  }
  &.cut {
    &:before {
      content: $icon-cut;
    }
  }
  &.star-alt {
    &:before {
      content: $icon-star-alt;
    }
  }
  &.number {
    &:before {
      content: $icon-number;
    }
  }
  &.button {
    &:before {
      content: $icon-button;
    }
  }
  &.emoji {
    &:before {
      content: $icon-emoji;
    }
  }
  &.arrow-down {
    &:before {
      content: $icon-arrow-down;
    }
  }
  &.arrow-up {
    &:before {
      content: $icon-arrow-up;
    }
  }
  &.gear {
    &:before {
      content: $icon-gear;
    }
  }
  &.radio-fill {
    &:before {
      content: $icon-radio-fill;
    }
  }
  &.radio {
    &:before {
      content: $icon-radio;
    }
  }
  &.checkbox-fill {
    &:before {
      content: $icon-checkbox-fill;
    }
  }
  &.alphabet {
    &:before {
      content: $icon-alphabet;
    }
  }
  &.align {
    &:before {
      content: $icon-align;
    }
  }
  &.magnifier {
    &:before {
      content: $icon-magnifier;
    }
  }
  &.circle-fill {
    &:before {
      content: $icon-circle-fill-path1;
    }
    &:after {
      content: $icon-circle-fill-path2;
      margin-left: -1em;
    }
  }
}
</style>
